module.exports = __webpack_public_path__ + "media/img/help_center/Student_Profile_01-fe98e9eb34d382a9466542e1df4aefb5.jpg";